import { Component, OnInit, ViewEncapsulation, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { InvoiceCheckListBus } from '@app/cp/shared/models/InvoiceCheckListBus';

import { CommonFunctions } from '@app/cp/shared/static/common-functions';
import { InvoiceService } from '@app/cp/shared/services/invoice.service';
import { BaseMessageInfo } from '@app/cp/shared/models/BaseMessageInfo';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";

@Component({
    selector: 'invoice-checklist',
    templateUrl: './invoice-checklist.component.html',
    styleUrls: ['./invoice-checklist.component.scss']
})
export class InvoiceChecklistComponent   {

    constructor(private svc_data: InvoiceService) {
    }
    @Input() gridData: InvoiceCheckListBus[];
    @Input() readOnly: boolean = false;
    @Input() mode: number = 1; //1-Invoice, 2-Dispatch
    selectedData: InvoiceCheckListBus;

    @Output() selected: EventEmitter<any> = new EventEmitter();
    @Output() closed: EventEmitter<any> = new EventEmitter();

    get cancelCaption(): string {
        return this.mode === 1 ? "Cancel" : "Ok";
    }
    change(e: any, index: number) {
        console.log("inv-cklst->change: ", e, e.target.checked, index);
        this.gridData[index].isChecked = e.target.checked;
    }
    close(e: any) {
        this.closed.emit(e);
    }
    cancelEvent() {
        this.close(false);
    }
    saveEvent() {
        this.close(true);
    }
    clear() {
        this.gridData = null;
        this.currentInvoiceId = null;
        this.currentCustomerId = null;
    }
    getGridData() : InvoiceCheckListBus[] {
        return this.gridData;
    }
    currentInvoiceId: any;
    currentCustomerId: any;

    setup(data: any, code: string = null) {
        if (CommonFunctions.hasArrayElementValue(data)) {
            let invoiceId = data[0];
            let customerId = data[1];
            let currentState = data[2];
            if(invoiceId !== this.currentInvoiceId || customerId !== this.currentCustomerId)
            {
                this.currentInvoiceId = invoiceId;
                this.currentCustomerId = customerId;
                this.svc_data.getChecklist(this.currentInvoiceId, this.currentCustomerId).subscribe((info: BaseMessageInfo) => {
                    let arr = [];

                    if (!info.saveError && CommonFunctions.hasArrayElementValue(info.primaryReturn)) {
                        for (let i = 0; i < info.primaryReturn.length; i++) {
                            let busObj: InvoiceCheckListBus = new InvoiceCheckListBus(info.primaryReturn[i]);
                            if (!CommonFunctions.hasGuidValue(busObj.invoiceId)) {
                                busObj.isAdded = true;
                            }
                            if (busObj?.states?.includes(currentState) || busObj?.states?.length == 0) {
                                arr.push(busObj);
                            }
                        }
                    }
                    this.gridData = arr;
                    console.log("inv-chk-set: ", info, this.gridData);
                });
            }
        }
    }

}

